// MobileMenuAddButton.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './MobileMenuAddButton.css';

// Icons
import Icon from 'svg/Icon';

const MobileMenuAddButton = ({ onClick, enabled = true }) => {

    // Theme Context
    const { theme } = useTheme();

    return (
        <>
            <div className="mobile-menu-add-button-container"
                onClick={() => {
                    if (!enabled) return;
                    onClick && onClick();
                }}
                style={{
                    cursor: enabled ? 'pointer' : 'not-allowed',
                    opacity: enabled ? 1 : 0.45,
                    //backgroundColor: "white",
                    //backgroundColor: "#00000044",
                }}
                title="Add">
                <Icon
                    iconKey="add"
                    color={theme.foreground}
                    width={33}
                    height={33}
                />
            </div>

        </>
    );
};

export default MobileMenuAddButton;
